// import Vue from 'vue'
import SocketIO from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';
import store from './store';
import { SOCKET_URL } from './utils/api';

// Vue-socket

export default (token) => {
  // const optionSocket = { autoConnect: true, query: `token=${token}` };
  const optionSocket = {
    autoConnect: true,
    query: `token=${token}`,
    transports: ['websocket', 'polling'], // force WebSocket first
  };
  return new VueSocketIO({
    debug: false,
    connection: SocketIO(SOCKET_URL, optionSocket), // options object is Optional
    vuex: {
      store,
      actionPrefix: 'SOCKET_',
      mutationPrefix: 'SOCKET_',
    },
  });
};
